module.exports = __webpack_public_path__ + "img/calendar2-fill.7217a359.svg";